<template>
  <div class="top__header">

    <Header/>

  </div>
</template>


<script>
import Header from "@/parts/Front/nicecomponents/subcomponents/Header";

export default {
  name: 'HomeHeader',
  components: {
    Header,
  }
};
</script> 


<style scoped>

.top__header {
  /* position: absolute; */
  width: 100%;
  margin:0 auto ;
  /* left: 0; */
  /* right: 0; */
  background-color: #fff;
  border-radius: 10px;
  z-index: 8;
}

@media screen and (max-width: 1200px) {
  

  .top__header >>> .menu {
    margin-right: -24px;
  }
}

@media screen and (max-width: 992px) {
  .top__header {
    margin-bottom: 16px;
  }
}
</style>
